import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const modalContentCss = "m1if0ao9";
export const ModalContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalContentCss, props.className)} />;
});
const closeButtonCss = "c102rn5s";
export const CloseButton = forwardRef((props, ref) => {
  const name = 'close';
  return <BareButton ref={ref} {...props} name={name} aria-label="Close" className={classNames(closeButtonCss, props.className)}>
      <CloseIcon />
    </BareButton>;
});
const styledLoaderCss = "stmc8dv";
export const StyledLoader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledLoaderCss, props.className)}>
      <Loader />
    </Component>;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");